<template>     
  <v-dialog v-model="dialog" persistent max-width="330">      
    <v-card>
      <v-card-title class="text-h5 text-center">
        Скинути прив'язку?
      </v-card-title>
      <v-card-text class="text-center">Ви впевнені, що хочете скинути прив'язку абонента?</v-card-text>
      <v-card-actions>
        <v-btn
          color="deep-orange darken-1"
          text
          @click="closeDialog()"
        >
          Ні
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary lighten-1"
          text
          @click="sendForm"
        >
          Так
        </v-btn>
      </v-card-actions>
    </v-card>   
  </v-dialog>
</template>

<script>
    import axios from "axios"
    //import { mapGetters } from "vuex"
	export default {
    name: 'modal-confirm-reset-binding',
    props: ['user_pcode'],
		data: () => ({
            loading:false,
            dialog: false,
            
        }),
        methods: {
            show(){
                this.dialog = true;
            },
            closeDialog (){
                this.dialog = false
            },
            sendForm() {
            this.loading = true;
            axios({
                method: "post",
                url: this.$router.app.devUrlBillingAPI,
                data: {req_cmd: "clearUserBinding", pcode: this.user_pcode }
            })
                .then(response => {
                if(response.data.resp_status == "OK"){
                    this.$emit('update-binding');
                    this.$router.app.$snack.show("Прив'язка скинута")
                    this.closeDialog()
                }else if(response.data.resp_status == "REJECT"){
                    this.$router.app.$snack.show(response.data.resp_errmsg, 'deep-orange')
                }else{
                    this.$router.app.$snack.show("Помилка скидання прив'язки", 'deep-orange')
                }
                })
                .catch(err => {
                //console.log(err);
                    this.$router.app.$sheet.show("Помилка! (billing)", err);
                })
                .finally(() => ( this.loading = false ))
                
            },
        }
    }
</script>